import type { DocumentData, QueryConstraint } from "firebase/firestore";
import { firestoreApi } from "../../../core/apis/firestoreApi";
import BaseApi from "../../../core/BaseApi";
import {
  type BusinessCustomerData,
  BusinessCustomerModel,
} from "./BusinessCustomerModel";

export default class BusinessCustomersApi extends BaseApi<
  BusinessCustomerModel,
  BusinessCustomerData
> {
  /* PRIVATE APIS */

  async getAllCustomers() {
    if (!this.stores.sessionStore.superUser.data.isDev) {
      throw new Error("Not authed");
    }

    const qs: QueryConstraint[] = [];

    const querySnapshots = await firestoreApi.queryDocuments(this.db, ...qs);

    const models: BusinessCustomerModel[] = [];

    querySnapshots.forEach((querySnapshot) => {
      models.push(this.fromFirestore(querySnapshot));
    });
    this.store.load(models);
  }

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}business_customers`;
  }

  get store() {
    return this.stores.businessCustomersStore;
  }

  fromFirestore(res: DocumentData): BusinessCustomerModel {
    return new BusinessCustomerModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
